document.addEventListener('DOMContentLoaded', () => {
    const buttonSelector = '.add-to-cart[data-product_id]';
    const badgeSelector = '.add-to-cart__qty-badge';
    const syncAction = 'kp_get_cart_quantities';
    const syncEvents = 'added_to_cart removed_from_cart wc_fragments_refreshed wc_fragments_loaded updated_wc_div';
    const wcBlocksEvents = [
        'wc-blocks_added_to_cart',
        'wc-blocks_removed_from_cart'
    ];
    let syncTimeoutId = null;

    const normalizeQuantity = (value) => {
        const parsedValue = Number.parseInt(value, 10);
        return Number.isNaN(parsedValue) || parsedValue < 0 ? 0 : parsedValue;
    };

    const getBadgeText = (quantity) => {
        return quantity > 99 ? '99+' : String(quantity);
    };

    const updateButtonBadge = (button, quantity) => {
        if (!button) {
            return;
        }

        const normalizedQty = normalizeQuantity(quantity);
        let badge = button.querySelector(badgeSelector);

        button.dataset.cartQty = String(normalizedQty);
        button.classList.toggle('has-cart-qty', normalizedQty > 0);

        if (normalizedQty <= 0) {
            if (badge) {
                badge.remove();
            }
            return;
        }

        if (!badge) {
            badge = document.createElement('span');
            badge.className = 'add-to-cart__qty-badge';
            badge.setAttribute('aria-hidden', 'true');
            button.prepend(badge);
        }

        badge.textContent = getBadgeText(normalizedQty);
    };

    const updateProductButtons = (productId, quantity) => {
        if (!productId) {
            return;
        }

        const productButtons = document.querySelectorAll(`${buttonSelector}[data-product_id="${productId}"]`);
        productButtons.forEach((button) => updateButtonBadge(button, quantity));
    };

    const initializeBadges = () => {
        const buttons = document.querySelectorAll(buttonSelector);

        buttons.forEach((button) => {
            const initialQty = normalizeQuantity(button.dataset.cartQty);
            updateButtonBadge(button, initialQty);
        });
    };

    const applyQuantitiesMap = (quantitiesMap) => {
        const buttons = document.querySelectorAll(buttonSelector);

        buttons.forEach((button) => {
            const productId = button.dataset.product_id;
            const quantity = productId ? normalizeQuantity(quantitiesMap[productId]) : 0;
            updateButtonBadge(button, quantity);
        });
    };

    const syncBadgesFromServer = async () => {
        if (typeof window.main === 'undefined' || !window.main.ajaxUrl || !window.main.nonce) {
            return;
        }

        const formData = new FormData();
        formData.append('action', syncAction);
        formData.append('nonce', window.main.nonce);

        try {
            const response = await fetch(window.main.ajaxUrl, {
                method: 'POST',
                credentials: 'same-origin',
                body: formData
            });

            if (!response.ok) {
                return;
            }

            const payload = await response.json();
            if (!payload || !payload.success || !payload.data || typeof payload.data.items !== 'object') {
                return;
            }

            applyQuantitiesMap(payload.data.items);
        } catch (error) {
            // Silent fallback: the page keeps server-rendered state until next successful sync.
        }
    };

    const cartHasPendingOperations = () => {
        try {
            if (!window.wp || !wp.data || typeof wp.data.select !== 'function') {
                return false;
            }
            const cart = wp.data.select('wc/store/cart');
            if (!cart || typeof cart.hasPendingItemsOperations !== 'function') {
                return false;
            }
            return !!cart.hasPendingItemsOperations();
        } catch (error) {
            return false;
        }
    };

    const scheduleSync = (delay = 250) => {
        if (syncTimeoutId) {
            window.clearTimeout(syncTimeoutId);
        }

        syncTimeoutId = window.setTimeout(() => {
            if (cartHasPendingOperations()) {
                scheduleSync(150);
                return;
            }
            syncBadgesFromServer();
        }, delay);
    };

    initializeBadges();

    if (typeof jQuery !== 'undefined') {
        jQuery(document.body).on('added_to_cart', (event, fragments, cartHash, button) => {
            if (!button || typeof button.attr !== 'function') {
                return;
            }

            const productId = button.attr('data-product_id');
            const currentQty = normalizeQuantity(button.attr('data-cart-qty'));
            const addedQty = Math.max(1, normalizeQuantity(button.attr('data-quantity')));
            const newQty = currentQty + addedQty;

            updateProductButtons(productId, newQty);
        });

        jQuery(document.body).on(syncEvents, () => {
            scheduleSync();
        });
    }

    wcBlocksEvents.forEach((eventName) => {
        document.body.addEventListener(eventName, () => {
            scheduleSync();
        }, true);
    });

    if (window.wp && wp.data && typeof wp.data.subscribe === 'function') {
        let wasPending = false;
        wp.data.subscribe(() => {
            const pending = cartHasPendingOperations();
            if (wasPending && !pending) {
                scheduleSync(200);
            }
            wasPending = pending;
        });
    }

    syncBadgesFromServer();
});
